import React from 'react';
import Record from './Record/Record';
import cssClasses from './MidSettings.css';
import CustomKnob from '../CustomKnob/CustomKnob'
import * as skins from "react-rotary-knob-skin-pack";
import {connect} from "react-redux";
import * as actionCreators from "../../store/actions";

class MidSettings extends React.Component {

    changeHandlerDistortion = (index, value) => {
        if (Math.abs(value - this.props.audios[index].distortion) >= 50)
            return;
        this.props.onChangeDistortionEffect(index, value)
    }
    changeHandlerFrequency = (index, value) => {
        if (Math.abs(value - this.props.audios[index].lowPassFilter.frequency) > 11025)
            return;
        this.props.onChangeFrequencyEffect(index, value)
    }
    changeHandlerPingPongDelay = (index, value) => {
        if (Math.abs(value - this.props.audios[index].delayMix) > 50)
            return;
        this.props.onChangePingPongDelayEffect(index, value)
    }

    render() {
        const {audios = []} = this.props;

        return (

            <React.Fragment>
                <div className={cssClasses.RecordButtonDiv}>
                    <Record/>
                </div>
                <div className={cssClasses.OtherSettings}>

                    <div className={cssClasses.Rows}>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s14}
                                min={50}
                                max={22050}
                                value={audios[0].lowPassFilter.frequency || 0}
                                knobName={'LP Frequency A'}
                                changeHandler={(value) => this.changeHandlerFrequency(0, value)}
                            />
                        </div>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s14}
                                min={50}
                                max={22050}
                                value={audios[1].lowPassFilter.frequency || 0}
                                knobName={'LP Frequency B'}
                                changeHandler={(value) => this.changeHandlerFrequency(1, value)}
                            />
                        </div>
                    </div>


                    <div className={cssClasses.Rows}>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                min={0}
                                max={100}
                                value={audios[0].delayMix || 0}
                                knobName={'Delay A'}
                                changeHandler={(value) => this.changeHandlerPingPongDelay(0, value)}
                            />
                        </div>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                min={0}
                                max={100}
                                value={audios[1].delayMix || 0}
                                knobName={'Delay B'}
                                changeHandler={(value) => this.changeHandlerPingPongDelay(1, value)}
                            />
                        </div>
                    </div>


                    <div className={cssClasses.Rows}>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s18}
                                min={0}
                                max={100}
                                value={audios[0].distortion || 0}
                                knobName={'Distortion A'}
                                changeHandler={(value) => this.changeHandlerDistortion(0, value)}
                            />
                        </div>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s18}
                                min={0}
                                max={100}
                                value={audios[1].distortion || 0}
                                knobName={'Distortion B'}
                                changeHandler={(value) => this.changeHandlerDistortion(1, value)}
                            />
                        </div>
                    </div>
                </div>

                <div className={cssClasses.MobileOtherSettings}>

                    <div className={cssClasses.Rows}>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s14}
                                min={50}
                                max={22050}
                                value={audios[0].lowPassFilter.frequency || 0}
                                knobName={'LP Frequency A'}
                                changeHandler={(value) => this.changeHandlerFrequency(0, value)}
                            />
                        </div>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                min={0}
                                max={100}
                                value={audios[0].delayMix || 0}
                                knobName={'Delay A'}
                                changeHandler={(value) => this.changeHandlerPingPongDelay(0, value)}
                            />
                        </div>
                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s18}
                                min={0}
                                max={100}
                                value={audios[0].distortion || 0}
                                knobName={'Distortion A'}
                                changeHandler={(value) => this.changeHandlerDistortion(0, value)}
                            />
                        </div>

                    </div>

                    <div className={cssClasses.Rows}>
                        <Record />
                    </div>

                    <div className={cssClasses.Rows}>

                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s14}
                                min={50}
                                max={22050}
                                value={audios[1].lowPassFilter.frequency || 0}
                                knobName={'LP Frequency B'}
                                changeHandler={(value) => this.changeHandlerFrequency(1, value)}
                            />
                        </div>

                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                min={0}
                                max={100}
                                value={audios[1].delayMix || 0}
                                knobName={'Delay B'}
                                changeHandler={(value) => this.changeHandlerPingPongDelay(1, value)}
                            />
                        </div>

                        <div className={cssClasses.Cols}>
                            <CustomKnob
                                skin={skins.s18}
                                min={0}
                                max={100}
                                value={audios[1].distortion || 0}
                                knobName={'Distortion B'}
                                changeHandler={(value) => this.changeHandlerDistortion(1, value)}
                            />
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        audios: state.audios
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeDistortionEffect: (audioIndex, value) => dispatch(actionCreators.onChangeDistortionEffect(audioIndex, value)),
        onChangeFrequencyEffect: (audioIndex, value) => dispatch(actionCreators.onChangeFrequencyEffect(audioIndex, value)),
        onChangePingPongDelayEffect: (audioIndex, value) => dispatch(actionCreators.onChangePingPongDelayEffect(audioIndex, value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MidSettings);